import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 6 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<mask id=\"a\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"6\" height=\"6\"><circle cx=\"3\" cy=\"3\" r=\"3\" fill=\"#D9D9D9\"></circle></mask><g mask=\"url(#a)\"><path d=\"M7.5 0h-9v6h9V0Z\" fill=\"#C00\"></path><path d=\"M7.5 0h-9v3h9V0Z\" fill=\"#000\"></path><path d=\"M3 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z\" fill=\"#FF0\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }